import { render, staticRenderFns } from "./WikiProposals.vue?vue&type=template&id=26aa4200&"
import script from "./WikiProposals.vue?vue&type=script&lang=js&"
export * from "./WikiProposals.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports